import { getAccessToken, getConfig, refresh } from "@/auth"

const directories = getConfig().directories

const getDataJson = async (url, headers) => {
	return await fetch(url, { headers })
		.then(x => {
			if (x.status >= 200 && x.status < 300) {
				return x.json()
			}

			if (x.status >= 500) {
				console.error('Что-то пошло не так. Попробуйте позже.')
				return {
					message: 'Что-то пошло не так. Попробуйте позже.',
					name: 'server-error',
					success: false
				}
			}

			if (x.status == 422) {
				console.error('Неправильный код, попробуйте снова.')
				return {
					message: 'Неправильный код, попробуйте снова.',
					name: 'wrong-captcha',
					success: false
				}
			}

			if (x.status >= 400 && x.status < 500) {
				if (x.status === 401) {
					refresh()
					return {
						message: 'Недостаточно прав',
						name: x.status,
						success: false
					}
				}
				console.error('Ошибка HTTP: ' + x.status)
				return {
					message: 'Ошибка HTTP: ' + x.status,
					name: x.status,
					success: false
				}
			}
		})
}

const getDataWithToken = async (url) => {
	return await getDataJson(url, {
		'Authorization': 'Bearer ' + getAccessToken(),
	})
}

const getData = async (filters = {zones : ''}) => {
	let local_governments = (await getDataJson(directories.local_governments)).data
	let zones = (await getDataJson(`${directories.zones}?${filters.zones}`)).data
	let types = (await getDataJson(directories.types)).data
	let socials = (await getDataJson(directories.socials)).data
	let user_types = (await getDataJson(directories.user_types)).data

	return { local_governments, zones, types, socials, user_types }
}

const getDataReg = async () => {
	let sources = (await getDataJson(directories.sources)).data
	let doc_types = (await getDataJson(directories.doc_types)).data

	return { sources, doc_types }
}

export { getDataJson, getData, getDataReg, getDataWithToken, directories as urls }